import script from "./BigDataMonitor.vue?vue&type=script&setup=true&lang=ts"
export * from "./BigDataMonitor.vue?vue&type=script&setup=true&lang=ts"

import "./BigDataMonitor.vue?vue&type=style&index=0&id=5596e09e&scoped=true&lang=scss"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5596e09e"]])

export default __exports__